<!--
 * @Author: your name
 * @Date: 2020-08-13 20:52:36
 * @LastEditTime: 2022-12-09 09:27:12
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/order-history/index.vue
-->
<style scoped lang="sass">
.order_history
  padding-top: 10px
::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour) !important

</style>
<style lang="sass" scoped>
.order_history
  .has_order_history

    .user_login
      padding: 20px 17px 0 17px
      font-size: 12px
      color: rgba(51, 68, 85, .75)
      letter-spacing: 0.6px

      .to_login
        margin-top: 8px
        padding: 8px 0
        font-weight: 500
        color: var(--menu-primary-background-colour)

  .footer_common
    position: fixed
    bottom: 0
</style>

<template lang="pug">
  .order_history
    .has_order_history(v-if="orders.length")
      van-list.overflow_scroll(
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        @load="onLoad"
      )
        history-order(v-for="item in orders" :key="item.id" :order="item")
        .user_login(v-if="1 < 0")
          p {{ t('previous_orders_not_visible', "Have you placed previous orders you can't see here?") }}
          p.to_login(@click="toLogin") {{ t('retrieve_order_history', 'RETRIEVE FULL ORDER HISTORY') }}
      footer-common.footer_common(:text="text" @clickButton="clickButton")
    none-history-order(v-else)

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import HistoryOrder from '@/views/order-history/component/HistoryOrder'
import NoneHistoryOrder from '@/views/order-history/component/noneHistoryOrder'
import { getUserOrders } from '@/api/product'
import { mapState } from 'vuex'
import { _encodeBase64 } from 'utils/base64'
import { MessageDialog } from '@/plugins/createApi'
import failIcon from '@/assets/tab-pics/warning-icon.png'
import { t } from '@/utils/language'

@Component({

  props: {
    venueSubGroupId: String
  },

  computed: {
    ...mapState(['userPhone', 'userCode']),
    ...mapState({
      routerInfo: state => state.venueHome.routerInfo
    }),
  },

  components: {
    HistoryOrder,
    NoneHistoryOrder
  },

  created() {
    this.fromPage = this.$route.query.fromPage
  },

  async mounted() {
    this.userId = localStorage.getItem('userId')
    if (this.userId || this.userPhone) {
      this.$store.commit('showLoading')
      await this._updateOrder()
    }
    if ((!this.total) && this.$route.query.isVerificationCode) {
      MessageDialog.$create({
        $props: {
          icon: failIcon,
          content: t('no_order_history_venue', 'You have no order history with this venue.'),
          buttonText: t('ok', 'OK')
        },
      }).show()
    }
  },

  beforeDestroy() {
    this._clearTimeout()
  }
})

class SubGroupOrderHistory extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  fromPage = ''
  text = t('order_more', 'ORDER MORE')
  orders = []
  userId = ''
  total = 0
  pageSize = 20
  pageNo = 1
  loading = false
  finished = false
  setTimeout = null

  clickButton() {
    if (this.fromPage) {

    } else {
      // this.$store.commit('clearProductList')
    }
    const tableNumber = this.routerInfo.number
    if (tableNumber) {
      this.$router.push(`/vgs/${this.venueSubGroupId}/home/t/${tableNumber}`)
    } else {
      this.$router.push(`/vgs/${this.venueSubGroupId}/`)
    }
  }

  // Bottom loading data
  // 触底加载数据
  async onLoad() {
    // If all data has been loaded, stop loading
    // 若已加载全部数据，停止继续加载
    if (this.orders.length === Number(this.total)) {
      this.finished = true
      return
    }
    this.pageNo++
    this.loading = true
    try {
      this._clearTimeout()
      await this._getOrders()
      this.loading = false
      this.$store.commit('closeLoading')
      this._updateOrder()
    } catch {
      this.loading = false
      this.$store.commit('closeLoading')
    }
  }

  toLogin() {
    this.$router.push(`/vgs/${this.venueSubGroupId}/login/enter-phone-number`)
  }

  // Get order information every 10s
  // 每 10s 获取订单信息
  async _updateOrder() {
    await this._updateOrderStatus()
    this.setTimeout = setTimeout(async _ => {
      await this._updateOrder()
    }, 10000)
  }

  // Update order status
  // 更新订单状态
  async _updateOrderStatus() {
    const res = await this._postOrder(1)
    this.total = res.total
    this.$store.commit('closeLoading')
    // When orders are not greater than pageSize, directly overwrite res.orders to orders
    // orders 不大于 pageSize 时，直接把 res.orders 覆盖给 orders
    if (this.orders.length <= this.pageSize) {
      this.orders = res.orders
      return
    }
    this.orders = this.orders.map((item, index) => {
      // Update the data on the first page, and use the original data for the rest
      // 更新第一页数据，其余还采用原数据
      if (index >= res.orders.length) {
        return item
      }
      return res.orders[index]
    })
  }

  // Drop down to load order list
  // 下拉加载订单列表
  async _getOrders() {
    const res = await this._postOrder(this.pageNo).catch(function (e) {
      console.log(e)
      return false
    })
    this.orders = [...this.orders, ...res.orders]
  }

  // Get order list
  // 获取订单列表
  async _postOrder(pageNo) {
    let userPhoneCountryCode = this.userCode ? this.userCode.trim() : ''
    if (userPhoneCountryCode[0] !== '+') userPhoneCountryCode = '+' + userPhoneCountryCode
    return await getUserOrders({
      venueSubGroupId: this.venueSubGroupId,
      venueId: this.venueSubGroupId,
      type: 'venueSubGroupOrder',
      id: this.userId,
      pageSize: this.pageSize,
      pageNo,
      userPhone: _encodeBase64(this.userPhone),
      userPhoneCountryCode
    }).catch(function (e) {
      console.log(e)
      return false
    })
  }

  // Clear Timeout
  // 清除 Timeout
  _clearTimeout() {
    clearTimeout(this.setTimeout)
  }
}

export default SubGroupOrderHistory
</script>
